export const savedItemToScrollTo = () =>
  window.history.state && window.history.state.persistedItemPosition;

export const saveItemPosition = (position: number | undefined) =>
  window.history.replaceState(
    { ...(window.history.state || {}), persistedItemPosition: position },
    document.title,
    window.location.toString(),
  );
